import type { Map } from "ol";
import { reloadController, getRosreestrLayers, getRosreestrLabelsLayers } from "../../layers";
import { store } from "../../../../../stateManagement/store";
import { setNumberOfSelectedRosreestrObjects, setSelectedRosreestrObjectsByGroupId } from "../../../../../stateManagement/reducers/RosreestrSlice";
import { setHighlightObjectGeoJSON, showToastMessage } from "../../../../../stateManagement/reducers";
import { fetchRosreestrObjectCardStructureByCategoryId } from "../../../../../api/rosreestrApi";
import { customGetFeatureInfoUrl } from "../getObjectsOnMapPoint/getObjectsOnMapPoint";
import { getItemWebStorage, setItemWebStorage } from "../../../../../features/webStorageSaver";
import { cursorStyleFunctions } from "../../helpers";
import { delay } from "../../../../../features/dataFunctions/dataFunctions";

export const rosreestrLayersGroups: any = {
    0: "Единицы кадастрового деления",
    1: "Объекты капитального строительства",
    2: "Земельные участки из ЕГРН",
    3: "Зоны с особыми условиями использования территории",
    4: "Природные территории"
}

export const rosreestrLayersSettings: any = {
    okrug: {
        name: "36945",
        objectsCategoryId: "38030",
        objectsSubcategoryId: "1",
        caption: "Кадастровые округа",
        singleCaption: "Кадастровый округ",
        groupId: 0
    },
    raion: {
        name: "36070",
        caption: "Кадастровые районы",
        singleCaption: "Кадастровый район",
        groupId: 0
    },
    kvartal: {
        name: "36071",
        caption: "Кадастровые кварталы",
        singleCaption: "Кадастровый квартал",
        groupId: 0
    },
    building: {
        name: "36049",
        labelsName: "855342",
        objectsCategoryId: "36369",
        objectsSubcategoryId: "1",
        caption: "Здания",
        singleCaption: "Здание",
        groupId: 1
    },
    construction: {
        name: "36328",
        objectsCategoryId: "36383",
        objectsSubcategoryId: "1",
        caption: "Сооружения",
        singleCaption: "Сооружение",
        groupId: 1
    },
    unfinishedBuilding: {
        name: "36329",
        objectsCategoryId: "36384",
        objectsSubcategoryId: "2",
        caption: "Объекты незавершенного строительства",
        singleCaption: "Объект незавершенного строительства",
        groupId: 1
    },
    landPlots: {
        name: "36048",
        labelsName: "855413",
        objectsCategoryId: "36368",
        objectsSubcategoryId: "5",
        caption: "Земельные участки из ЕГРН",
        singleCaption: "Земельный участок из ЕГРН",
        groupId: 2
    },
    cultureZOUIT: {
        name: "37577",
        labelsName: "856832",
        objectsCategoryId: "36940",
        objectsSubcategoryId: "13",
        caption: "ЗОУИТ объектов культурного наследия",
        singleCaption: "ЗОУИТ объектов культурного наследия",
        groupId: 3
    },
    serviceZOUIT: {
        name: "37578",
        labelsName: "856833",
        objectsCategoryId: "36940",
        objectsSubcategoryId: "16",
        caption: "ЗОУИТ объектов энергетики, связи, транспорта",
        singleCaption: "ЗОУИТ объектов энергетики, связи, транспорта",
        groupId: 3
    },
    natureZOUIT: {
        name: "37580",
        labelsName: "856835",
        objectsCategoryId: "36940",
        objectsSubcategoryId: "7",
        caption: "ЗОУИТ природных территорий",
        singleCaption: "ЗОУИТ природных территорий",
        groupId: 3
    },
    secureZOUIT: {
        name: "37579",
        labelsName: "856834",
        objectsCategoryId: "36940",
        objectsSubcategoryId: "26",
        caption: "ЗОУИТ охраняемых объектов и безопасности",
        singleCaption: "ЗОУИТ охраняемых объектов и безопасности",
        groupId: 3
    },
    otherZOUIT: {
        name: "37581",
        labelsName: "856836",
        objectsCategoryId: "36940",
        objectsSubcategoryId: "41",
        caption: "Иные ЗОУИТ",
        singleCaption: "Иная ЗОУИТ",
        groupId: 3
    },
    specialZOUIT: {
        name: "36317",
        objectsCategoryId: "36948",
        objectsSubcategoryId: "1",
        caption: "Особо охраняемые природные территории",
        singleCaption: "Особо охраняемая природная территория",
        groupId: 3
    },
    forestry: {
        name: "36314",
        // labelsName: "855051",
        objectsCategoryId: "36945",
        objectsSubcategoryId: "1",
        caption: "Лесничества",
        singleCaption: "Лесничество",
        groupId: 4
    },
    coastlinesPolygonal: {
        name: "36469",
        objectsCategoryId: "36992",
        objectsSubcategoryId: "1",
        caption: "Береговые линии (границы водных объектов) (полигональный)",
        singleCaption: "Береговая линия",
        groupId: 4
    },
    coastlinesLinear: {
        name: "36470",
        objectsCategoryId: "37148",
        objectsSubcategoryId: "1",
        caption: "Береговые линии (границы водных объектов)(линейный)",
        singleCaption: "Береговая линия",
        groupId: 4
    }
}

export function browserHasRuCertificate() {
    const userAgent = window.navigator.userAgent?.toLowerCase();
    return (/yabrowser/.test(userAgent) || /atom/.test(userAgent) || /uran/.test(userAgent) || /sputnik/.test(userAgent));
}

export function activateRosreestrCadasterLayer(mapType: any, isRosreestrEnabled: boolean, setAlertsShowerText: any, map?: Map) {
    // Вывод ошибок Росреестра 
    const showRosreestrAlerts = (count: any) => {
        setAlertsShowerText(`Ошибок обращения к Росреестру: ${count?.toString()}`)
        delay(() => setAlertsShowerText(''), 8000)
    }
    const rosreestrLayers: any = getRosreestrLayers()
    const rosreestrLabelsLayers: any = getRosreestrLabelsLayers()
    if (isRosreestrEnabled && mapType != "card") {
        rosreestrLayers.map((layer: any) => {
            // Функции для обработки ошибки загрузки тайла
            layer.getSource()?.addEventListener('tileloaderror', (event: any) => {
                reloadController.onTileLoadError(event, showRosreestrAlerts);
            })
            map?.addLayer(layer)
        })
        rosreestrLabelsLayers.map((layer: any) => {
            // Функции для обработки ошибки загрузки тайла
            layer.getSource()?.addEventListener('tileloaderror', (event: any) => {
                reloadController.onTileLoadError(event, showRosreestrAlerts);
            })
            map?.addLayer(layer)
        })
    }
    return {
        off: () => {
            rosreestrLayers.map((layer: any) => {
                map?.removeLayer(layer);
            })
            rosreestrLabelsLayers.map((layer: any) => {
                map?.removeLayer(layer);
            })
        }
    }
}

export async function getRosreestrObjectCardStructure(categoryId: any) {
    const cardStructure: any = await fetchRosreestrObjectCardStructureByCategoryId(categoryId) ?? {}
    return cardStructure
}

export async function getRosreestrObjectsInfo(coordinates: any, zoom: any, projectionCode: any) {
    let [i, j] = coordinates
    const maxBboxSide = 1024
    const zoomForOneObject = 18
    const bboxSide = Math.min(Math.pow(4, zoomForOneObject - zoom), maxBboxSide) * 32
    const bboxHalfSide = bboxSide / 2
    const bbox = [i - bboxHalfSide, j - bboxHalfSide, i + bboxHalfSide, j + bboxHalfSide]
    const width = 512
    const height = 512
    i = width / 2
    j = height / 2
    const rosreestrLayers: any = getRosreestrLayers()
    const rosreestrLayersObjectsCategoriesIds = rosreestrLayers.map((rosreestrLayer: any) => {
        const layerName = rosreestrLayer?.getSource()?.getParams()?.LAYERS
        const rosreestrLayerSettings: any = Object.values(rosreestrLayersSettings).find((layerSettings: any) => layerSettings.name === layerName)
        const objectsCategoryId = rosreestrLayerSettings?.objectsCategoryId
        return objectsCategoryId
    }).filter((objectsCategoryId: any) => objectsCategoryId)
    let rosreestrCardsInfo: any = getItemWebStorage('rosreestrCardsInfo')
    const uniqueRosreestrLayersObjectsCategoriesIds = [...new Set(rosreestrLayersObjectsCategoriesIds)]
    await Promise.all(uniqueRosreestrLayersObjectsCategoriesIds.map(async (objectsCategoryId: any) => {
        let { cardStructure, titleStructure } = rosreestrCardsInfo?.[objectsCategoryId] ?? {}
        if (!cardStructure) {
            const { cardStructure: newCardStructure, titleStructure: newTitleStructure } = await getRosreestrObjectCardStructure(objectsCategoryId) ?? {}
            cardStructure = structuredClone(newCardStructure)
            titleStructure = structuredClone(newTitleStructure)
            rosreestrCardsInfo = {
                ...rosreestrCardsInfo,
                [objectsCategoryId]: {
                    cardStructure,
                    titleStructure
                }
            }
        }
    }))
    let numberOfSelectedRosreestrObjects = 0
    let selectedRosreestrObjectsByGroupId: any = {}
    let newSelectedRosreestrObjectsGeometry: any = []
    let receivedObjectsTypesIdsSet: any = new Set()
    await Promise.all(rosreestrLayers.map(async (rosreestrLayer: any) => {
        const layerName = rosreestrLayer?.getSource()?.getParams()?.LAYERS
        const layersNamesWithoutFeatureInfo = ["36070", "36071"]
        if (!layersNamesWithoutFeatureInfo.includes(layerName)) {
            const rosreestrLayerSettings: any = Object.values(rosreestrLayersSettings).find((layerSettings: any) => layerSettings.name === layerName)
            const { objectsCategoryId, objectsSubcategoryId, groupId } = rosreestrLayerSettings ?? {}
            const urls: any = rosreestrLayer?.getSource()?.getUrls()
            const wmsUrl = urls[0]
            const url = customGetFeatureInfoUrl(wmsUrl, layerName, projectionCode, width, height, i, j, bbox)
            if (url) {
                await fetch(url)
                    .then((response) => response.json())
                    .then(async (data) => {
                        const features = data?.features
                        const filteredFeatures = features.filter((feature: any) => feature.properties.subcategory == objectsSubcategoryId)
                        if (filteredFeatures.length > 0) {
                            const featuresProperties = filteredFeatures.map(({ id, properties }: any) => { return { ...properties, objectId: id } })
                            selectedRosreestrObjectsByGroupId = {
                                ...selectedRosreestrObjectsByGroupId,
                                [groupId]: {
                                    ...selectedRosreestrObjectsByGroupId[groupId],
                                    [objectsCategoryId]: {
                                        ...selectedRosreestrObjectsByGroupId[groupId]?.[objectsCategoryId],
                                        [objectsSubcategoryId]: featuresProperties
                                    }
                                }
                            }
                            const featuresGeometries = filteredFeatures.map((feature: any) => feature.geometry)
                            newSelectedRosreestrObjectsGeometry = [...newSelectedRosreestrObjectsGeometry, ...featuresGeometries]
                            const objectsTypeId = `category:${objectsCategoryId}, subcategory:${objectsSubcategoryId}`
                            if (!receivedObjectsTypesIdsSet.has(objectsTypeId)) {
                                numberOfSelectedRosreestrObjects += filteredFeatures.length
                                receivedObjectsTypesIdsSet.add(objectsTypeId);
                            }
                        }
                    })
                    .catch((error) => {
                        cursorStyleFunctions.default();
                        console.error('GetFeatureInfo error:', error);
                        store.dispatch(showToastMessage({messageText: 'Ошибка получения данных с карты', messageType: "error", windowType: "map"}))
                    });
            }
        }
    }));
    store.dispatch(setSelectedRosreestrObjectsByGroupId(selectedRosreestrObjectsByGroupId))
    store.dispatch(setHighlightObjectGeoJSON(newSelectedRosreestrObjectsGeometry))
    store.dispatch(setNumberOfSelectedRosreestrObjects(numberOfSelectedRosreestrObjects))
    setItemWebStorage('rosreestrCardsInfo', rosreestrCardsInfo)
}